import { UserTicketDto } from '../../types';

export enum StepsIds {
  DefaultOptions = 'defaultOptions',
  TransferredOptions = 'transferredOptions',
  ConfirmRevokeStep = 'confirmRevokeStep',
  RequestRefundStep = 'requestRefundStep'
}

export type GoToStepFn = (step: StepsIds) => void;

export type StepProps = {
  goToStep: GoToStepFn;
  ticket: UserTicketDto;
  onClose: () => void;
  refetchTickets: () => void;
};
